import * as React from 'react';

import InteractiveContext from 'views/components/contexts/InteractiveContext';
import type { Evidence } from 'security-app/components/Investigations/Details/TimelineSegment/types';

import EvidenceCardFoundation from './EvidenceCardFoundation';

const EvidenceLogCard = ({ evidence }: { evidence: Evidence }) => (
  <InteractiveContext.Provider value={false}>
    <EvidenceCardFoundation
      title={<span>{evidence.entity.id}</span>}
      actions={undefined}
      onShowSimilar={undefined}
      hasSimilarFieldsFilter={false}
      evidence={evidence}
      isHighlighted={false}
      onResetShowSimilar={() => {}}
    />
  </InteractiveContext.Provider>
);

export default EvidenceLogCard;
